module.exports = __webpack_public_path__ + "img/user.f8c31b52.svg";